(function () {
  var FIRST_REWARD_CENTS = 10000;
  var SECOND_REWARD_CENTS = 30000;
  var FIRST_REWARD_NAME = "Heat-Resistant Gloves & Diamond Pins Tool Set";
  var SECOND_REWARD_NAME = "QuickStyle Flat Iron";
  var FIRST_REWARD_URL = "https://koollia.com/products/heat-resistant-anti-slip-glove-1-pack-diamond-pin64mm-50-alligator-clips-2-pieces";
  var SECOND_REWARD_URL = "https://koollia.com/products/quickstyle-flat-iron-koollia-recommendation-wig-stylist-tools";
  var FIRST_REWARD_IMAGE = "https://koollia.com/cdn/shop/files/20260729-123512.png?v=1785351709&width=600";
  var SECOND_REWARD_IMAGE = "https://koollia.com/cdn/shop/files/koollia-mini-cordless-hair-straightener-flat-iron.jpg?v=1780891657&width=600";

  function hasReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function canAnimate() {
    return !hasReducedMotion() && (window.gsap || (window.Element && Element.prototype.animate));
  }

  function getTargets(targets) {
    if (!targets) return [];
    if (targets instanceof Element) return [targets];
    return Array.prototype.slice.call(targets);
  }

  function easeToCss(ease) {
    if (!ease) return "ease-out";
    if (ease.indexOf("power2") === 0) return "cubic-bezier(0.22, 1, 0.36, 1)";
    if (ease.indexOf("power3") === 0) return "cubic-bezier(0.16, 1, 0.3, 1)";
    return "ease-out";
  }

  function frameFromVars(vars) {
    var frame = {};
    var transforms = [];

    if (typeof vars.y !== "undefined") transforms.push("translateY(" + vars.y + "px)");
    if (typeof vars.scale !== "undefined") transforms.push("scale(" + vars.scale + ")");
    if (transforms.length) frame.transform = transforms.join(" ");
    if (typeof vars.autoAlpha !== "undefined") frame.opacity = vars.autoAlpha;
    if (typeof vars.opacity !== "undefined") frame.opacity = vars.opacity;
    if (typeof vars.width !== "undefined") frame.width = vars.width;

    return frame;
  }

  function animateTo(targets, vars) {
    if (!canAnimate()) return;
    if (window.gsap) {
      window.gsap.to(targets, vars);
      return;
    }

    getTargets(targets).forEach(function (target) {
      var toFrame = frameFromVars(vars);
      target.animate([toFrame], {
        duration: Math.round((vars.duration || 0.4) * 1000),
        easing: easeToCss(vars.ease),
        fill: "forwards"
      });
    });
  }

  function animateFromTo(targets, fromVars, toVars) {
    if (!canAnimate()) return;
    if (window.gsap) {
      window.gsap.fromTo(targets, fromVars, toVars);
      return;
    }

    var nodes = getTargets(targets);
    var eachDelay = toVars.stagger ? Math.round(toVars.stagger * 1000) : 0;
    nodes.forEach(function (target, index) {
      var animation = target.animate([frameFromVars(fromVars), frameFromVars(toVars)], {
        duration: Math.round((toVars.duration || 0.5) * 1000),
        delay: eachDelay * index,
        easing: easeToCss(toVars.ease),
        fill: "both"
      });

      animation.addEventListener("finish", function () {
        target.style.opacity = "";
        target.style.transform = "";
        target.style.visibility = "";
      });
    });
  }

  function formatMoney(cents) {
    return "$" + (Math.max(0, cents) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function giftStatusMarkup(total) {
    var giftName = FIRST_REWARD_NAME;
    var giftUrl = FIRST_REWARD_URL;
    var giftImage = FIRST_REWARD_IMAGE;
    var tag = "$100 gift";
    var note = formatMoney(FIRST_REWARD_CENTS - total) + " away";

    if (total >= SECOND_REWARD_CENTS) {
      giftName = SECOND_REWARD_NAME;
      giftUrl = SECOND_REWARD_URL;
      giftImage = SECOND_REWARD_IMAGE;
      tag = "$300 unlocked";
      note = "Add it in cart before checkout";
    } else if (total >= FIRST_REWARD_CENTS) {
      tag = "$100 unlocked";
      note = "Add it in cart before checkout";
    }

    var mediaHtml = giftImage
      ? '<img src="' + giftImage + '" alt="' + escapeHtml(giftName) + '" width="240" height="240" loading="lazy">'
      : '<span class="kll-june-cart-rail__gift-fallback">?</span>';

    var tagName = giftUrl && giftUrl !== "#" ? "a" : "div";
    var href = tagName === "a" ? ' href="' + giftUrl + '"' : "";

    return '<' + tagName + ' class="kll-june-cart-rail__gift"' + href + '>' +
      '<span class="kll-june-cart-rail__gift-media">' + mediaHtml + '</span>' +
      '<span class="kll-june-cart-rail__gift-copy"><span>' + tag + '</span><strong>' + escapeHtml(giftName) + '</strong><em>' + escapeHtml(note) + '</em></span>' +
    '</' + tagName + '>';
  }

  function updateRewardCart(page, state) {
    var totalNode = page.querySelector("[data-kll-cart-total]");
    var statusNode = page.querySelector("[data-kll-cart-status]");
    var progressNode = page.querySelector("[data-kll-cart-progress]");
    var progressTrack = page.querySelector(".kll-june-cart-rail__track");
    var itemsNode = page.querySelector("[data-kll-cart-items]");
    var total = state.baseCents + state.items.reduce(function (sum, item) {
      return sum + item.priceCents;
    }, 0);
    var progress = Math.min(100, Math.round((total / SECOND_REWARD_CENTS) * 100));

    if (totalNode) totalNode.textContent = formatMoney(total);
    if (progressNode) {
      if (canAnimate()) {
        animateTo(progressNode, {
          width: progress + "%",
          duration: 0.45,
          ease: "power2.out",
          overwrite: "auto"
        });
      } else {
        progressNode.style.width = progress + "%";
      }
    }
    if (progressTrack) progressTrack.setAttribute("aria-valuenow", String(Math.round(total / 100)));

    if (statusNode) {
      if (total < FIRST_REWARD_CENTS) {
        statusNode.textContent = formatMoney(FIRST_REWARD_CENTS - total) + " to unlock " + FIRST_REWARD_NAME + ".";
      } else if (total < SECOND_REWARD_CENTS) {
        statusNode.textContent = FIRST_REWARD_NAME + " unlocked \u2014 " + formatMoney(SECOND_REWARD_CENTS - total) + " to the next gift.";
      } else {
        statusNode.textContent = "All gifts unlocked \u2014 add yours in cart before checkout.";
      }
    }

    if (!itemsNode) return;
    itemsNode.innerHTML = giftStatusMarkup(total);
  }

  function addVariantToShopifyCart(variantId) {
    if (!variantId || !window.fetch) {
      return Promise.resolve();
    }

    return window.fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart add failed");
      return response.json();
    });
  }

  function setupRewardBarBehavior(page) {
    var shop = page.querySelector(".kll-june-shop");
    var shopMain = page.querySelector(".kll-june-shop__main");
    var rail = page.querySelector("[data-kll-cart-rail]");
    if (!shop || !rail) return;
    var wasFollowing = false;
    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop;

    // Simplified header detection — same approach as the June page (which works)
    function getVisibleHeaderOffset() {
      var header = document.querySelector("sticky-header, .shopify-section-header, .header-wrapper, header");
      if (!header) return 12;
      var rect = header.getBoundingClientRect();
      // Lenient check: header is visible near top (allows for headers mid-animation)
      var isVisibleAtTop = rect.bottom > 0 && rect.top < 20;
      if (!isVisibleAtTop) return 12;
      return Math.round(rect.bottom + 8);
    }

    function updateCompactState() {
      var rect = shop.getBoundingClientRect();
      var mainRect = shopMain ? shopMain.getBoundingClientRect() : rect;
      var topOffset = getVisibleHeaderOffset();
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
      var scrollingUp = currentScrollY < lastScrollY;
      lastScrollY = currentScrollY;

      var isMobile = window.matchMedia("(max-width: 749px)").matches;
      // Standard condition: product grid near header AND shop not yet scrolled past
      var standardFollow = mainRect.top <= topOffset + 24 && rect.bottom > topOffset + 160;

      var shouldFollow;
      if (isMobile && wasFollowing && scrollingUp) {
        // Mobile scrolling up: keep bar fixed under nav as long as shop is still in view
        // (prevents bar from disappearing when nav slides back in from top)
        shouldFollow = rect.bottom > topOffset + 80;
      } else {
        shouldFollow = standardFollow;
      }

      page.style.setProperty("--kll-reward-top", topOffset + "px");
      page.classList.toggle("is-reward-fixed", shouldFollow);
      page.classList.toggle("is-reward-compact", shouldFollow);

      if (canAnimate() && shouldFollow && !wasFollowing) {
        animateFromTo(rail, {
          y: -10,
          autoAlpha: 0.96
        }, {
          y: 0,
          autoAlpha: 1,
          duration: 0.22,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "transform,opacity,visibility"
        });
      }

      wasFollowing = shouldFollow;

      if (!shouldFollow) {
        rail.classList.remove("is-expanded");
      }
    }

    rail.addEventListener("click", function (event) {
      if (!page.classList.contains("is-reward-compact")) return;
      if (event.target.closest("[data-kll-cart-add]")) return;
      rail.classList.toggle("is-expanded");

      if (canAnimate() && rail.classList.contains("is-expanded")) {
        animateFromTo(rail, {
          y: -4
        }, {
          y: 0,
          duration: 0.18,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "transform"
        });
      }
    });

    document.addEventListener("click", function (event) {
      if (!rail.classList.contains("is-expanded")) return;
      if (rail.contains(event.target)) return;
      rail.classList.remove("is-expanded");
    });

    window.addEventListener("scroll", updateCompactState, { passive: true });
    window.addEventListener("resize", updateCompactState);
    updateCompactState();
  }

  function revealGroup(nodes, options) {
    if (!canAnimate() || !nodes.length) return;

    animateFromTo(nodes, {
      y: options && options.y ? options.y : 18,
      autoAlpha: 0
    }, {
      y: 0,
      autoAlpha: 1,
      duration: options && options.duration ? options.duration : 0.62,
      ease: "power2.out",
      stagger: options && options.stagger ? options.stagger : 0.08,
      overwrite: "auto",
      clearProps: "transform,opacity,visibility"
    });
  }

  function setupEntranceAnimations(page) {
    if (!canAnimate()) return;

    var hero = page.querySelector(".kll-june-hero");
    if (hero) {
      var heroIntro = hero.querySelectorAll(".kll-june-hero__pill-wrapper, h1, .kll-june-hero__desc");
      var heroActions = hero.querySelectorAll(".kll-june-hero__actions > *");

      if (window.gsap) {
        var heroTimeline = window.gsap.timeline({
          defaults: {
            duration: 0.72,
            ease: "power2.out"
          }
        });

        heroTimeline.from(heroIntro, {
          y: 16,
          autoAlpha: 0,
          stagger: 0.08
        });

        if (heroActions.length) {
          heroTimeline.from(heroActions, {
            y: 10,
            autoAlpha: 0,
            duration: 0.45,
            stagger: 0.08
          }, "<0.35");
        }
      } else {
        revealGroup(heroIntro, {
          y: 16,
          stagger: 0.08,
          duration: 0.58
        });

        revealGroup(heroActions, {
          y: 10,
          stagger: 0.08,
          duration: 0.42
        });
      }
    }

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var section = entry.target;
        observer.unobserve(section);

        if (section.classList.contains("kll-june-campaign")) {
          revealGroup(section.querySelectorAll(".kll-june-campaign__header > *, .kll-june-reward-card, .kll-june-campaign__actions > *"), {
            stagger: 0.06,
            y: 14
          });
        } else if (section.classList.contains("kll-june-shop")) {
          revealGroup(section.querySelectorAll(".kll-june-shop__head > *, .kll-june-tabs, .kll-june-cart-rail, [data-kll-product-card]:not([hidden])"), {
            stagger: 0.045,
            y: 12
          });
        } else if (section.classList.contains("kll-june-faq")) {
          revealGroup(section.querySelectorAll(".kll-june-faq__head > *, .kll-june-faq__item"), {
            stagger: 0.06,
            y: 12
          });
        }
      });
    }, {
      threshold: 0.16
    });

    page.querySelectorAll(".kll-june-campaign, .kll-june-shop, .kll-june-faq").forEach(function (section) {
      observer.observe(section);
    });
  }

  function setupCityMotion(page) {
    if (hasReducedMotion()) return;

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (!gsap || !ScrollTrigger) {
      setupEntranceAnimations(page);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    var hero = page.querySelector(".kll-city-hero");
    var campaign = page.querySelector(".kll-june-campaign");
    var shop = page.querySelector(".kll-june-shop");
    var faq = page.querySelector(".kll-june-faq");

    if (hero) {
      var heroIntro = gsap.timeline({
        defaults: { duration: 0.82, ease: "power3.out" }
      });

      heroIntro
        .from(hero.querySelectorAll(".kll-june-hero__pill-wrapper"), {
          x: -22,
          autoAlpha: 0
        })
        .from(hero.querySelectorAll(".kll-june-hero__title-top, .kll-june-hero__title-bottom"), {
          yPercent: 108,
          autoAlpha: 0,
          stagger: 0.1
        }, "<0.14")
        .from(hero.querySelectorAll(".kll-june-hero__desc"), {
          y: 18,
          autoAlpha: 0
        }, "<0.34")
        .from(hero.querySelectorAll(".kll-june-hero__actions > *"), {
          y: 14,
          autoAlpha: 0,
          stagger: 0.08,
          duration: 0.5
        }, "<0.22")
        .from(hero.querySelectorAll(".kll-city-hero__route-line"), {
          scaleY: 0,
          transformOrigin: "top center",
          duration: 1.05
        }, 0.18)
        .from(hero.querySelectorAll(".kll-city-hero__station, .kll-city-hero__route-label"), {
          scale: 0.6,
          autoAlpha: 0,
          stagger: 0.11,
          duration: 0.42
        }, 0.44);

      var ticker = hero.querySelector("[data-kll-city-ticker]");
      if (ticker) {
        gsap.to(ticker, {
          xPercent: -50,
          duration: 24,
          ease: "none",
          repeat: -1
        });
      }

      var grid = hero.querySelector(".kll-city-hero__grid");
      if (grid) {
        gsap.to(grid, {
          yPercent: 12,
          ease: "none",
          scrollTrigger: {
            trigger: hero,
            start: "top top",
            end: "bottom top",
            scrub: 0.7
          }
        });
      }

      if (window.matchMedia("(min-width: 990px)").matches) {
        var content = hero.querySelector(".kll-city-hero__content");
        var route = hero.querySelector(".kll-city-hero__route");
        var contentX = content ? gsap.quickTo(content, "x", { duration: 0.7, ease: "power3.out" }) : null;
        var contentY = content ? gsap.quickTo(content, "y", { duration: 0.7, ease: "power3.out" }) : null;
        var routeX = route ? gsap.quickTo(route, "x", { duration: 0.9, ease: "power3.out" }) : null;
        var routeY = route ? gsap.quickTo(route, "y", { duration: 0.9, ease: "power3.out" }) : null;

        hero.addEventListener("pointermove", function (event) {
          var rect = hero.getBoundingClientRect();
          var px = (event.clientX - rect.left) / rect.width - 0.5;
          var py = (event.clientY - rect.top) / rect.height - 0.5;
          if (contentX) contentX(px * 12);
          if (contentY) contentY(py * 8);
          if (routeX) routeX(px * -18);
          if (routeY) routeY(py * -12);
        }, { passive: true });

        hero.addEventListener("pointerleave", function () {
          if (contentX) contentX(0);
          if (contentY) contentY(0);
          if (routeX) routeX(0);
          if (routeY) routeY(0);
        }, { passive: true });
      }
    }

    if (campaign) {
      var campaignTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: campaign,
          start: "top 74%",
          toggleActions: "play none none reverse"
        },
        defaults: {
          duration: 0.72,
          ease: "power3.out"
        }
      });

      campaignTimeline
        .from(campaign.querySelectorAll(".kll-june-campaign__header > *"), {
          y: 24,
          autoAlpha: 0,
          stagger: 0.08
        })
        .from(campaign.querySelectorAll(".kll-city-reward-line i"), {
          scaleX: 0,
          transformOrigin: "left center",
          stagger: 0.16
        }, "<0.18")
        .from(campaign.querySelectorAll(".kll-city-reward-line button"), {
          scale: 0.5,
          autoAlpha: 0,
          stagger: 0.1,
          duration: 0.42
        }, "<0.12")
        .from(campaign.querySelectorAll(".kll-june-reward-card"), {
          y: 38,
          autoAlpha: 0,
          stagger: 0.12
        }, "<0.1")
        .from(campaign.querySelectorAll(".kll-june-campaign__actions > *"), {
          y: 16,
          autoAlpha: 0,
          stagger: 0.08,
          duration: 0.48
        }, "<0.25");
    }

    if (shop) {
      gsap.from(shop.querySelectorAll(".kll-june-shop__head > *, .kll-june-tabs, .kll-june-cart-rail"), {
        y: 24,
        autoAlpha: 0,
        stagger: 0.08,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: shop,
          start: "top 76%",
          toggleActions: "play none none reverse"
        }
      });

      ScrollTrigger.batch(shop.querySelectorAll("[data-kll-product-card]"), {
        start: "top 88%",
        once: true,
        interval: 0.08,
        batchMax: function () {
          return window.matchMedia("(max-width: 749px)").matches ? 2 : 4;
        },
        onEnter: function (batch) {
          gsap.fromTo(batch, {
            y: 28,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1,
            duration: 0.65,
            ease: "power3.out",
            stagger: 0.07,
            overwrite: "auto",
            clearProps: "transform,opacity,visibility"
          });
        }
      });
    }

    if (faq) {
      gsap.from(faq.querySelectorAll(".kll-june-faq__head > *, .kll-june-faq__item"), {
        y: 20,
        autoAlpha: 0,
        stagger: 0.07,
        duration: 0.64,
        ease: "power3.out",
        scrollTrigger: {
          trigger: faq,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    }

    var pendingImages = page.querySelectorAll("img");
    var remaining = pendingImages.length;
    function refreshAfterImages() {
      remaining -= 1;
      if (remaining <= 0) ScrollTrigger.refresh();
    }

    if (!remaining) {
      ScrollTrigger.refresh();
    } else {
      pendingImages.forEach(function (image) {
        if (image.complete) {
          refreshAfterImages();
        } else {
          image.addEventListener("load", refreshAfterImages, { once: true });
          image.addEventListener("error", refreshAfterImages, { once: true });
        }
      });
    }
  }

  function setupRouteNavigation(page) {
    var buttons = Array.prototype.slice.call(page.querySelectorAll("[data-kll-route-index]"));
    var cards = Array.prototype.slice.call(page.querySelectorAll("[data-kll-route-card]"));
    var heroRoute = page.querySelector(".kll-city-hero__route");
    var rewardLines = Array.prototype.slice.call(page.querySelectorAll(".kll-city-reward-line i"));

    if (!buttons.length || !cards.length) return;

    function activateRoute(index, highlightCard) {
      var numericIndex = Math.max(1, Math.min(3, Number(index) || 1));
      var progress = (numericIndex - 1) / 2;

      buttons.forEach(function (button) {
        var isActive = Number(button.getAttribute("data-kll-route-index")) === numericIndex;
        button.classList.toggle("is-active", isActive);
        if (isActive) {
          button.setAttribute("aria-current", "step");
        } else {
          button.removeAttribute("aria-current");
        }
      });

      cards.forEach(function (card) {
        var isTarget = Number(card.getAttribute("data-kll-route-card")) === numericIndex;
        card.classList.toggle("is-route-target", Boolean(highlightCard && isTarget));
      });

      rewardLines.forEach(function (line, lineIndex) {
        line.classList.toggle("is-complete", lineIndex < numericIndex - 1);
      });

      if (heroRoute) {
        heroRoute.style.setProperty("--kll-route-progress", String(progress));
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        activateRoute(button.getAttribute("data-kll-route-index"), true);
      });
    });

    cards.forEach(function (card) {
      card.addEventListener("pointerenter", function () {
        activateRoute(card.getAttribute("data-kll-route-card"), false);
      }, { passive: true });
      card.addEventListener("focusin", function () {
        activateRoute(card.getAttribute("data-kll-route-card"), false);
      });
    });

    activateRoute(1, false);
  }

  function setupTabScrollHint(page) {
    var tabs = page.querySelector(".kll-june-tabs");
    if (!tabs) return;

    function updateHint() {
      var maxScroll = tabs.scrollWidth - tabs.clientWidth;
      // No overflow, or scrolled (almost) to the end -> drop the fade hint
      var atEnd = maxScroll <= 1 || tabs.scrollLeft >= maxScroll - 2;
      tabs.classList.toggle("is-scroll-end", atEnd);
    }

    tabs.addEventListener("scroll", updateHint, { passive: true });
    window.addEventListener("resize", updateHint);
    updateHint();

    function resetHorizontalDrift() {
      var node = tabs.parentElement;

      while (node && node !== document.body && node !== document.documentElement) {
        if (node !== tabs && node.scrollLeft) {
          node.scrollLeft = 0;
        }
        node = node.parentElement;
      }

      if (document.documentElement.scrollLeft) {
        document.documentElement.scrollLeft = 0;
      }
      if (document.body.scrollLeft) {
        document.body.scrollLeft = 0;
      }
    }

    // Keep the active tab visible without letting Shopify's mobile preview
    // horizontally scroll the whole page.
    tabs.querySelectorAll("[data-kll-filter]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        resetHorizontalDrift();

        var maxScroll = tabs.scrollWidth - tabs.clientWidth;
        if (maxScroll <= 1) {
          resetHorizontalDrift();
          return;
        }

        var tabLeft = tab.offsetLeft;
        var tabWidth = tab.offsetWidth;
        var targetLeft = tabLeft - (tabs.clientWidth - tabWidth) / 2;
        targetLeft = Math.max(0, Math.min(maxScroll, targetLeft));

        if (typeof tabs.scrollTo === "function") {
          tabs.scrollTo({ left: targetLeft, behavior: "smooth" });
        } else {
          tabs.scrollLeft = targetLeft;
        }

        resetHorizontalDrift();
        window.requestAnimationFrame(resetHorizontalDrift);
        window.setTimeout(resetHorizontalDrift, 160);
      });
    });
  }

  function setupFaq(page) {
    page.querySelectorAll(".kll-june-faq__question").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".kll-june-faq__item");
        var isOpen = item && item.classList.contains("is-open");

        page.querySelectorAll(".kll-june-faq__item").forEach(function (faqItem) {
          var faqButton = faqItem.querySelector(".kll-june-faq__question");
          faqItem.classList.remove("is-open");
          if (faqButton) faqButton.setAttribute("aria-expanded", "false");
        });

        if (item && !isOpen) {
          item.classList.add("is-open");
          button.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  var pages = document.querySelectorAll("[data-kll-june-page]");
  if (!pages.length) return;

  pages.forEach(function (page) {
    FIRST_REWARD_NAME = page.getAttribute("data-kll-first-reward-name") || FIRST_REWARD_NAME;
    SECOND_REWARD_NAME = page.getAttribute("data-kll-second-reward-name") || SECOND_REWARD_NAME;
    FIRST_REWARD_URL = page.getAttribute("data-kll-first-reward-url") || FIRST_REWARD_URL;
    SECOND_REWARD_URL = page.getAttribute("data-kll-second-reward-url") || SECOND_REWARD_URL;
    FIRST_REWARD_IMAGE = page.getAttribute("data-kll-first-reward-image") || FIRST_REWARD_IMAGE;
    SECOND_REWARD_IMAGE = page.getAttribute("data-kll-second-reward-image") || SECOND_REWARD_IMAGE;

    var state = {
      baseCents: Number(page.getAttribute("data-kll-cart-cents")) || 0,
      items: []
    };

    page.querySelectorAll("[data-kll-scroll-target]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        var selector = button.getAttribute("data-kll-scroll-target");
        var target = selector ? page.querySelector(selector) || document.querySelector(selector) : null;

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: hasReducedMotion() ? "auto" : "smooth",
          block: button.hasAttribute("data-kll-route-index") ? "center" : "start"
        });
      });
    });

    page.querySelectorAll("[data-kll-filter]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var category = tab.getAttribute("data-kll-filter");
        page.querySelectorAll("[data-kll-filter]").forEach(function (otherTab) {
          var isActive = otherTab === tab;
          otherTab.classList.toggle("is-active", isActive);
          otherTab.setAttribute("aria-selected", String(isActive));
        });

        page.querySelectorAll("[data-kll-product-card]").forEach(function (card) {
          card.hidden = card.getAttribute("data-category") !== category;
        });

        revealGroup(page.querySelectorAll('[data-kll-product-card][data-category="' + category + '"]:not([hidden])'), {
          stagger: 0.035,
          y: 10,
          duration: 0.46
        });
      });
    });

    page.querySelectorAll("[data-kll-cart-add]").forEach(function (button) {
      button.addEventListener("click", function () {
        var title = button.getAttribute("data-title") || "Selected product";
        var priceCents = Number(button.getAttribute("data-price-cents")) || 0;
        var variantId = button.getAttribute("data-variant-id");
        var originalText = button.textContent;

        button.disabled = true;
        button.textContent = "Adding...";

        addVariantToShopifyCart(variantId).then(function () {
          state.items.push({
            title: title,
            priceCents: priceCents
          });

          button.classList.add("is-added");
          button.textContent = "Added";
          if (canAnimate()) {
            animateFromTo(button, {
              scale: 0.98
            }, {
              scale: 1,
              duration: 0.18,
              ease: "power2.out",
              overwrite: "auto",
              clearProps: "transform"
            });
          }
          updateRewardCart(page, state);
        }).catch(function () {
          button.textContent = "Try again";
        }).finally(function () {
          window.setTimeout(function () {
            button.disabled = false;
            button.classList.remove("is-added");
            button.textContent = originalText;
          }, 1200);
        });
      });
    });

    setupRouteNavigation(page);
    setupCityMotion(page);
    setupRewardBarBehavior(page);
    setupTabScrollHint(page);
    setupFaq(page);
    updateRewardCart(page, state);
  });
})();
